<template>
	<div class="FactoryDetail">
		<common-body aside="6">
			<div slot="commonMain" class="quotation_box" v-loading.lock="loadingStatus">
				<div v-if="detail">
					<el-row type="flex" align="middle" justify="space-between" class="quotation_header">
						<el-row type="flex" align="middle" class="location_box">
							<div class="location_icon">
								<i class="el-icon-s-promotion"></i>
							</div>
							<el-row type="flex" align="middle" class="location_text">
								<div>当前位置：</div>
								<el-button @click="goBack" type="text">生产查询</el-button>
								<div class="location_xie">/</div>
								<div>查看详情</div>
							</el-row>
						</el-row>
						<el-row type="flex" align="middle" class="header_r">
							<div @click="labelStatus=true" class="header_btn header_btn3">打印标签</div>
							<div @click="printQuotation(4)" v-if="detail.category==2" class="header_btn header_btn1">
								打印加工单</div>
							<div @click="printCutting" v-if="detail.category==2" class="header_btn header_btn4">
								打印切料优化</div>
							<div @click="printQuotation(3)" class="header_btn header_btn2">打印发货单</div>
						</el-row>
					</el-row>
					<el-form label-position="right" :model="detail" class="quotation_form">
						<div class="detail_info_section">
							<el-tabs v-model="infoTab" type="card" class="detail_info_tabs">
								<el-tab-pane label="订货清单" name="goods">
									<div class="detail_goods_panel">
										<el-row type="flex" justify="space-between" class="quotation_info quotation_info--view">
											<div class="quotation_info_col">
												<div class="info-view-item">
													<div class="info-view-label">
														<span class="info-view-label__text">
															<i v-for="(ch, i) in labelChars('单号')" :key="'a'+i">{{ ch }}</i>
														</span>
													</div>
													<div class="info-view-value">{{ displayText(detail.order_number) }}</div>
												</div>
												<div class="info-view-item info-view-item--address">
													<div class="info-view-label">
														<span class="info-view-label__text">
															<i v-for="(ch, i) in labelChars('收货地址')" :key="'b'+i">{{ ch }}</i>
														</span>
													</div>
													<div class="info-view-value info-view-value--multiline">{{ displayText(detail.receiving_address) }}</div>
												</div>
											</div>
											<div class="quotation_info_col">
												<div class="info-view-item">
													<div class="info-view-label">
														<span class="info-view-label__text">
															<i v-for="(ch, i) in labelChars('客户名称')" :key="'c'+i">{{ ch }}</i>
														</span>
													</div>
													<div class="info-view-value">{{ displayText(detail.customer_id) }}</div>
												</div>
												<div class="info-view-item">
													<div class="info-view-label">
														<span class="info-view-label__text">
															<i v-for="(ch, i) in labelChars('联系人')" :key="'d'+i">{{ ch }}</i>
														</span>
													</div>
													<div class="info-view-value">{{ displayText(detail.contacts) }}</div>
												</div>
												<div class="info-view-item">
													<div class="info-view-label">
														<span class="info-view-label__text">
															<i v-for="(ch, i) in labelChars('联系电话')" :key="'e'+i">{{ ch }}</i>
														</span>
													</div>
													<div class="info-view-value">{{ displayText(detail.contacts_phone) }}</div>
												</div>
											</div>
											<div class="quotation_info_col">
												<div class="info-view-item">
													<div class="info-view-label">
														<span class="info-view-label__text">
															<i v-for="(ch, i) in labelChars('报价日期')" :key="'f'+i">{{ ch }}</i>
														</span>
													</div>
													<div class="info-view-value">{{ displayText(detail.createTime) }}</div>
												</div>
												<div class="info-view-item">
													<div class="info-view-label">
														<span class="info-view-label__text">
															<i v-for="(ch, i) in labelChars('运输方式')" :key="'g'+i">{{ ch }}</i>
														</span>
													</div>
													<div class="info-view-value">{{ displayText(detail.delivery_text) }}</div>
												</div>
												<div class="info-view-item">
													<div class="info-view-label">
														<span class="info-view-label__text">
															<i v-for="(ch, i) in labelChars('发票类型')" :key="'h'+i">{{ ch }}</i>
														</span>
													</div>
													<div class="info-view-value">{{ displayText(detail.invoice_text) }}</div>
												</div>
											</div>
										</el-row>
										<el-table border stripe class="printTable" :data="detail.goodslist" style="width: 100%" cell-class-name="good_text" header-cell-class-name="good_header">
							<el-table-column :resizable="resizeable" align="center" min-width="3%" label="序号">
								<template slot-scope="scope">
									<div>{{scope.$index+1}}</div>
								</template>
							</el-table-column>
							<el-table-column :resizable="resizeable" align="center" min-width="10%" label="名称">
								<template slot-scope="scope">
									<el-popover
										placement="top"
										trigger="hover"
										:open-delay="2000"
										popper-class="factory-good-popover">
										<div class="good_reference">
											<img :src="scope.row.sku_image_text" />
										</div>
										<div slot="reference" class="good_name">{{ cartDisplayName(scope.row) }}</div>
									</el-popover>
								</template>
							</el-table-column>
							<el-table-column v-if="detail.category!=13&&detail.category!=19&&detail.category!=29&&detail.category!=30&&detail.category!=31&&detail.category!=40&&detail.category!=43&&detail.category!=45" :resizable="resizeable" align="center" min-width="12%" label="尺寸(mm)">
								<template slot-scope="scope">
									<div class="good_size">
										<div v-if="scope.row.goods_valuation==1">-</div>
										<div v-else>{{ formatSizeText(scope.row.size_text) }}</div>
									</div>
								</template>
							</el-table-column>
							<el-table-column :resizable="resizeable" align="center" min-width="12%" label="规格参数">
								<template slot-scope="scope">
									<div class="good_size">{{ scope.row.parameter_text }}</div>
								</template>
							</el-table-column>
							<el-table-column v-if="detail.category==20||detail.category==25||detail.category==26||detail.category==27||detail.category==28||detail.category==32||detail.category==33||detail.category==44" :resizable="resizeable" align="center" min-width="4%" prop="goods_areas" label="面积(㎡)">
							</el-table-column>
							<el-table-column :resizable="resizeable" align="center" min-width="4%" prop="goods_unit" label="单位">
							</el-table-column>
							<el-table-column :resizable="resizeable" align="center" min-width="4%" prop="goods_num" label="数量">
							</el-table-column>
							<el-table-column :resizable="resizeable" align="center" min-width="10%" label="备注" class-name="print-col-remark" header-class-name="print-col-remark">
								<template slot-scope="scope">
									<div class="good_remark_text">{{ scope.row.remarks == '' ? '无' : scope.row.remarks }}</div>
								</template>
							</el-table-column>
						</el-table>
						<div class="goods_footer">
							<div class="goods_footer_item goods_footer_item--remark">
								<div class="goods_footer_remark_block">
									<div class="goods_footer_remark_row">
										<div class="goods_footer_remark_label">订单备注：</div>
										<div class="goods_footer_remark_content">{{ detail.remarks || ' ' }}</div>
									</div>
									<div class="goods_footer_text goods_footer_maker">制单人：{{ detail.user_name }}</div>
								</div>
							</div>
						</div>
						<div v-if="printGoodsStats.detailRows.length" class="print-goods-stats">
							<div class="print-goods-stats__head">
								<span class="print-goods-stats__title">统计</span>
								<span class="print-goods-stats__sub">产品 <span class="num">{{ printGoodsStats.productTypeText }}</span> 类</span>
							</div>
							<div class="print-goods-stats__list">
								<div
									v-for="g in printGoodsStats.detailRows"
									:key="g.kind + '-' + g.key"
									class="print-goods-stats__row">
									<div class="print-goods-stats__name">{{ g.label }}</div>
									<div class="print-goods-stats__fields">
										<div class="print-goods-stats__field print-goods-stats__field--length">
											<template v-if="g.kind === 'length'">
												<span class="print-goods-stats__label">总长度</span>
												<span class="num">{{ g.lengthText }}</span>
												<span class="print-goods-stats__unit">mm</span>
											</template>
										</div>
										<div class="print-goods-stats__field print-goods-stats__field--qty">
											<span class="print-goods-stats__label">共</span>
											<span class="num">{{ g.qtyText }}</span>
											<span class="print-goods-stats__unit">{{ g.kind === 'length' ? '支' : '个' }}</span>
										</div>
									</div>
								</div>
							</div>
						</div>
									</div>
								</el-tab-pane>
								<el-tab-pane label="订单信息" name="order">
									<div class="detail_order_panel">
									<div class="detail_info_panel detail_info_panel--logistics">
										<el-form :rules="logisticsRules" ref="deliverForm" label-position="left" label-suffix="" :model="deliverForm" class="deliver_form logistics_form">
											<div class="logistics-form-row logistics-form-row--status">
												<div class="logistics-form-label">状态：</div>
												<div class="logistics-form-content logistics-form-content--status">
													<template v-if="canEditLogistics">
														<div class="logistics-status-layout">
															<el-radio-group
																:value="deliverForm.logistics_status"
																class="logistics-status-group"
																@input="onLogisticsStatusChange">
																<div class="logistics-status-option">
																	<el-radio label="1">未发货</el-radio>
																</div>
																<div class="logistics-status-option">
																	<el-radio label="2">已发货</el-radio>
																</div>
															</el-radio-group>
															<el-form-item
																class="logistics-info-item"
																:class="{'logistics-info-item--hidden': deliverForm.logistics_status !== '2'}"
																label="物流信息"
																prop="order_sn">
																<el-input
																	type="textarea"
																	resize="none"
																	:clearable="clearable"
																	placeholder="请输入物流信息"
																	v-model="deliverForm.order_sn"></el-input>
															</el-form-item>
														</div>
													</template>
													<div v-else class="logistics-status-layout logistics-status-layout--readonly">
														<div class="logistics-status-readonly">
															<div class="logistics-status-option">
																<span class="logistics-status-readonly-item" :class="{'is-active': deliverForm.logistics_status === '1'}">未发货</span>
															</div>
															<div class="logistics-status-option">
																<span class="logistics-status-readonly-item" :class="{'is-active': deliverForm.logistics_status === '2'}">已发货</span>
															</div>
														</div>
														<div
															class="logistics-info-readonly"
															:class="{'logistics-info-readonly--hidden': deliverForm.logistics_status !== '2'}">
															<div class="logistics-info-readonly-label logistics-info-vertical-label">物流信息</div>
															<div class="logistics-info-readonly-value">{{ displayText(deliverForm.order_sn) }}</div>
														</div>
													</div>
												</div>
											</div>
											<div class="logistics-form-row logistics-form-row--files">
												<div class="logistics-form-label">附件：</div>
												<div class="logistics-form-content logistics-form-content--files">
													<imageUpload
														v-model="deliverForm.logistics_files"
														:limit="uploadLimit"
														:multiple="true"
														:fileType="fileType"
														compact
														:cell-size="72" />
												</div>
											</div>
											<div class="logistics-form-row logistics-form-row--deliver">
												<div class="logistics-form-label">发货人：</div>
												<div class="logistics-form-content logistics-form-content--deliver">
													<div class="logistics-deliver-line">
														<el-form-item prop="deliver" class="logistics-deliver-item">
															<el-select
																v-if="canEditLogistics"
																class="logistics-deliver-select"
																v-model="deliverForm.deliver"
																placeholder="请选择发货人"
																:clearable="clearable">
																<el-option
																	v-for="name in deliverOptions"
																	:key="name"
																	:label="name"
																	:value="name" />
															</el-select>
															<div v-else class="logistics-deliver-readonly">{{ displayText(deliverForm.deliver) }}</div>
														</el-form-item>
														<div v-if="canEditLogistics || canSaveShippedLogistics" class="deliver_btn" @click="submitForm('deliverForm')">保存</div>
														<div v-if="showLogisticsModifyBtn" class="deliver_btn deliver_btn--modify" @click="enableLogisticsEdit">修改</div>
													</div>
												</div>
											</div>
										</el-form>
									</div>
									</div>
								</el-tab-pane>
							</el-tabs>
						</div>
						<!-- <el-form-item>
							<div class="quotation_btn" @click="delOffer">删除单据</div>
						</el-form-item> -->
					</el-form>
				</div>
			</div>
		</common-body>
		<el-dialog title="打印标签" center :visible.sync="labelStatus">
			<div class="label_box">
				<el-table max-height="400" ref="multipleTable" :data="labelData" tooltip-effect="dark"
					style="width: 100%" @selection-change="handleSelectionChange">
					<el-table-column align="center" type="selection" width="55"></el-table-column>
					<el-table-column align="center" prop="goods_name" label="名称" min-width="20%"></el-table-column>
					<el-table-column align="center" prop="goods_model" label="编号" min-width="14%"></el-table-column>
					<el-table-column align="center" prop="goods_size" label="尺寸(mm)" min-width="14%"></el-table-column>
					<el-table-column align="center" prop="goods_direction" label="出线方向" min-width="14%">
					</el-table-column>
					<el-table-column align="center" prop="goods_num" label="数量" min-width="20%">
						<template slot-scope="scope">
							<el-input-number v-model="scope.row.goods_num" :min="1" label="商品数量" size="small">
							</el-input-number>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="goods_remarks" label="备注" min-width="18%"></el-table-column>
				</el-table>
				<el-row type="flex" align="middle" justify="center" class="label_btns">
					<div @click="printLabel" class="label_btn">打印</div>
					<div class="label_status" :class="{'label_status1': printStatus==='正常'}">打印机连接状态：<span>{{printStatus}}</span></div>
				</el-row>
			</div>
		</el-dialog>
		<el-dialog title="附件预览" :visible.sync="logisticsPreviewVisible" width="800px" append-to-body>
			<img v-if="logisticsPreviewUrl" :src="logisticsPreviewUrl" class="logistics-preview-image" />
		</el-dialog>
		<el-dialog
			title="发货库存冲正"
			:visible.sync="reverseDialogVisible"
			width="720px"
			append-to-body
			:close-on-click-modal="false">
			<p class="reverse-hint">订单已改回「未发货」。请勾选需要冲正回库存的物料（可不选，表示保持已扣减）。</p>
			<el-table
				ref="reverseTable"
				:data="reverseCandidates"
				border
				size="small"
				max-height="360"
				@selection-change="onReverseSelectionChange">
				<el-table-column type="selection" width="48" align="center" />
				<el-table-column prop="material_code" label="编码" min-width="110" />
				<el-table-column prop="material_name" label="物料" min-width="160" />
				<el-table-column prop="unit" label="单位" width="70" />
				<el-table-column prop="qty_text" label="可冲正数量" width="110" align="right" />
			</el-table>
			<span slot="footer">
				<el-button @click="skipReverse">不冲正</el-button>
				<el-button type="primary" :loading="reverseSaving" :disabled="!reverseSelected.length" @click="confirmReverse">
					冲正所选
				</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import ImageUpload from '@/components/ImageUpload'
	import {
		getT
	} from "../assets/js/public.js"
	import { cartDisplayName } from '@/utils/cart-display'
	import { buildCartGoodsStats } from '@/utils/cart-stats'
	const CDN_BASE = (process.env.CDN_BASE || 'http://127.0.0.1:19000/baojia-system').replace(/\/$/, '')
	const IMAGE_EXT = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp']
	export default {
		name: 'FactoryDetail',
		components: {
			ImageUpload
		},
		data() {
			let that = this
			return {
				offer_id: 7,
				userInfo: JSON.parse(localStorage.getItem('userInfo')),
				readonly: !0,
				resizeable: !1,
				clearable: !0,
				border: !0,
				loadingStatus: !0,
				detail: null,
				infoTab: 'goods',
				factoryStatus: !1,
				deliverForm: {
					id: '',
					order_sn: "",
					deliver: "",
					logistics_status: '1',
					logistics_files: ""
				},
				deliverOptions: ['陈丽君', '李明娣'],
				uploadLimit: 9,
				fileType: ["jpg", "jpeg", "png", "pdf", "dxf", "dws", "dwg"],
				logisticsPreviewVisible: !1,
				logisticsPreviewUrl: '',
				labelStatus: !1,
				labelData: [],
				labelList: [],
				printStatus: "正常",
				logisticsEditMode: !1,
				reverseDialogVisible: !1,
				reverseCandidates: [],
				reverseSelected: [],
				reverseSaving: !1,
			}
		},
		beforeRouteLeave(to, from, next) {
			if (to.name === 'Factory') {
				to.meta.keepAlive = !0
			}
			next()
		},
		created() {
			this.reload();
		},
		computed: {
			/** 与报价/打印页「统计」一致：按 SKU/规格汇总长度与支数 */
			printGoodsStats() {
				const list = this.detail && Array.isArray(this.detail.goodslist) ? this.detail.goodslist : []
				return buildCartGoodsStats(list)
			},
			canEditLogistics() {
				return this.detail && (String(this.detail.status) === '1' || this.logisticsEditMode)
			},
			/** 已发货后仍可上传附件并保存（不必先点「修改」） */
			canSaveShippedLogistics() {
				return this.detail && String(this.detail.status) === '2' && !this.logisticsEditMode
			},
			showLogisticsModifyBtn() {
				return this.detail && String(this.detail.status) === '2' && !this.logisticsEditMode
			},
			logisticsRules() {
				const that = this
				return {
					order_sn: [{
						validator(rule, value, callback) {
							if (that.deliverForm.logistics_status === '2' && !(value || '').trim()) {
								callback(new Error('物流信息不能为空'))
								return
							}
							callback()
						},
						trigger: 'blur'
					}]
				}
			},
			logisticsFileList() {
				return this.parseLogisticsFiles(this.deliverForm.logistics_files)
			}
		},
		methods: {
			cartDisplayName,
			displayText(val) {
				return val !== undefined && val !== null && val !== '' ? val : '—'
			},
			labelChars(text) {
				return Array.from(String(text || ''))
			},
			onLogisticsStatusChange(val) {
				const next = String(val) === '2' ? '2' : '1'
				const prev = String(this.deliverForm.logistics_status) === '2' ? '2' : '1'
				if (next === prev) return
				const label = next === '2' ? '已发货' : '未发货'
				const that = this
				that.$confirm('确定将状态改为「' + label + '」吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(function() {
					that.applyLogisticsStatus(next, prev)
				}).catch(function() {})
			},
			applyLogisticsStatus(next, prev) {
				this.deliverForm.logistics_status = next
				if (next !== '2' && this.$refs.deliverForm) {
					this.$refs.deliverForm.clearValidate('order_sn')
				}
				if (next === '1' && prev === '2') {
					this.deliverForm.order_sn = ''
					this.deliverForm.logistics_files = ''
					this.deliverForm.deliver = ''
				}
			},
			formatSizeText(text) {
				if (text === undefined || text === null || text === '' || text === '-') return text
				return String(text).replace(/长/g, '')
			},
			resolveFileUrl(path) {
				if (!path) return ''
				if (/^https?:\/\//i.test(path)) return path
				return CDN_BASE + (path.startsWith('/') ? path : '/' + path)
			},
			parseLogisticsFiles(value) {
				if (!value) return []
				const list = Array.isArray(value) ? value : String(value).split(',')
				return list.map((item) => {
					const path = String(item || '').trim()
					if (!path) return null
					const ext = path.split('.').pop().toLowerCase()
					return {
						path,
						url: this.resolveFileUrl(path),
						isImage: IMAGE_EXT.indexOf(ext) > -1
					}
				}).filter(Boolean)
			},
			previewLogisticsFile(file) {
				if (!file) return
				if (file.isImage) {
					this.logisticsPreviewUrl = file.url
					this.logisticsPreviewVisible = !0
					return
				}
				window.open(file.url, '_blank')
			},
			syncDeliverForm(detail) {
				const isShipped = String(detail.status) === '2'
				this.deliverForm.logistics_status = isShipped ? '2' : '1'
				if (isShipped) {
					this.deliverForm.order_sn = detail.order_sn || ''
					this.deliverForm.logistics_files = detail.logistics_files || ''
					const deliver = detail.deliver || ''
					if (this.logisticsEditMode) {
						this.deliverForm.deliver = this.deliverOptions.indexOf(deliver) > -1 ? deliver : ''
					} else {
						this.deliverForm.deliver = deliver
					}
				} else {
					this.deliverForm.order_sn = ''
					this.deliverForm.logistics_files = ''
					this.deliverForm.deliver = ''
				}
			},
			enableLogisticsEdit() {
				this.logisticsEditMode = !0
				const deliver = this.detail.deliver || ''
				this.deliverForm.deliver = this.deliverOptions.indexOf(deliver) > -1 ? deliver : ''
				this.$nextTick(() => {
					if (this.$refs.deliverForm) this.$refs.deliverForm.clearValidate()
				})
			},
			reload() {
				let that = this
				that.offer_id = that.$route.query.id, that.deliverForm.id = that.$route.query.id, that.getDetail(), that
					.getList()
			},
			getDetail() {
				let that = this
				that.$fetch('addons/hlm/api.Order/getOderDetails', {
					id: that.offer_id
				}).then(function(res) {
					console.log(res)
					if (res.code == 1) {
						let detail = res.data
						detail.createTime = getT(detail.offertime * 1000), detail.sendTime = getT(detail.sendtime *
							1000)
						that.detail = detail, that.loadingStatus = !1
						that.syncDeliverForm(detail)
					}
				}).catch(function(error) {
					console.log(error)
				})
			},
			// 获取标签列表
			getList() {
				let that = this
				that.$fetch('addons/hlm/api.Prints/printsList', {
					order_id: that.offer_id
				}).then(function(res) {
					console.log(res)
					if (res.code == 1) {
						that.labelData = res.data.list,that.printStatus = res.data.prints;
					}
				}).catch(function(error) {
					console.log(error)
				})
			},
			// 选择标签
			handleSelectionChange(val) {
				this.labelList = val;
			},
			// 打印
			printLabel() {
				let that = this
				if(that.labelList.length===0){
					that.$message({
						message: '请选择需要打印的商品',
						type: 'warning'
					});
					return;
				}
				let goodsList = that.labelList.map((item,index)=>{
					let option = {
						order_goods_id: item.id,
						goods_num: item.goods_num,
						order_id: that.offer_id
					};
					return option;
				});
				that.$post('addons/hlm/api.Prints/addprints', {
					goodsList: JSON.stringify(goodsList)
				}).then(function(res) {
					console.log(res)
					if (res.code == 1) {
						that.$message({
							message: '打印成功',
							type: 'success'
						}),that.labelStatus = !1;
					}
				}).catch(function(error) {
					console.log(error)
				})
			},
			delOffer() {
				let that = this
				that.$confirm('此操作将永久删除该单据, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					that.$fetch('addons/hlm/api.order/del', {
						id: that.offer_id
					}).then(function(res) {
						console.log(res)
						if (res.code == 1) {
							that.detailStatus = !1, that.$message({
								message: '删除成功',
								type: 'success',
								duration: 1500,
								center: !0,
								onClose() {
									that.$router.goBack()
								}
							})
						}
					}).catch(function(error) {
						console.log(error)
					})
				}).catch(() => {
					that.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			onReverseSelectionChange(rows) {
				this.reverseSelected = rows || []
			},
			skipReverse() {
				this.reverseDialogVisible = !1
				this.reverseCandidates = []
				this.reverseSelected = []
				this.getDetail()
			},
			confirmReverse() {
				const that = this
				if (!that.reverseSelected.length) {
					that.$message.warning('请勾选要冲正的物料，或不冲正则点「不冲正」')
					return
				}
				that.reverseSaving = !0
				that.$post('addons/hlm/api.FactoryStock/shipReverse', {
					order_id: that.offer_id,
					ledger_ids: that.reverseSelected.map((r) => r.ledger_id).join(','),
				}).then(function(res) {
					if (res.code == 1) {
						that.$message.success(res.msg || '冲正成功')
						that.reverseDialogVisible = !1
						that.reverseCandidates = []
						that.reverseSelected = []
						that.getDetail()
					}
				}).finally(function() {
					that.reverseSaving = !1
				})
			},
			submitForm(deliverForm) {
				let that = this
				if (that.factoryStatus) return
				that.$refs[deliverForm].validate((valid) => {
					if (valid) {
						that.factoryStatus = !0
						that.$fetch('addons/hlm/api.Order/addLogistics', {
							id: that.deliverForm.id,
							order_sn: that.deliverForm.logistics_status === '2' ? that.deliverForm.order_sn : '',
							deliver: that.deliverForm.logistics_status === '2' ? that.deliverForm.deliver : '',
							shipped: that.deliverForm.logistics_status === '2' ? 1 : 0,
							logistics_files: that.deliverForm.logistics_status === '2' ? that.deliverForm.logistics_files : ''
						}).then(function(res) {
							console.log(res)
							if (res.code == 1) {
								that.logisticsEditMode = !1
								const stock = res.data || null
								if (stock && stock.need_reverse && stock.reverse_candidates && stock.reverse_candidates.length) {
									that.reverseCandidates = stock.reverse_candidates
									that.reverseSelected = []
									that.reverseDialogVisible = !0
									that.$message.success('已改回未发货，请选择是否冲正库存')
									that.factoryStatus = !1
									that.$nextTick(function() {
										if (that.$refs.reverseTable) {
											stock.reverse_candidates.forEach(function(row) {
												that.$refs.reverseTable.toggleRowSelection(row, true)
											})
										}
									})
									return
								}
								let tip = '保存成功'
								if (stock && stock.action === 'ship_deduct' && stock.deducted) {
									tip = '保存成功，已按配方扣减工厂库存'
								}
								that.$message({
									message: tip,
									type: 'success',
									duration: 1500,
									center: !0,
									onClose() {
										that.getDetail()
									}
								});
								that.factoryStatus = !1
							} else {
								that.factoryStatus = !1
							}
						}).catch(function(error) {
							console.log(error)
							that.factoryStatus = !1
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			printQuotation(e) {
				let that = this
				that.$router.push(`/print?id=${that.offer_id}&status=${e}`)
			},
			printCutting() {
				this.$router.push(`/cuttingPrint?id=${this.offer_id}`)
			},
			printInvoice() {
				let that = this
			},
			goBack() {
				this.$router.back()
			}
		}
	};
</script>

<style src='../assets/css/factoryDetail.css'>
	/* px2rem能正常转换 */
</style>
